import { useState, useMemo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";
import ContentStudio from "@/pages/admin/ContentStudio";
import ReelsStudio from "@/pages/admin/ReelsStudio";
import NewsletterPanel from "@/pages/admin/NewsletterPanel";
import BroadcastComposer from "@/pages/admin/BroadcastComposer";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";
import ImmunocalPage from "@/pages/pillar/ImmunocalPage";
import ImmunocalPrecioPage from "@/pages/pillar/ImmunocalPrecioPage";
import GlutationPage from "@/pages/pillar/GlutationPage";
import SistemaInmunologicoPage from "@/pages/pillar/SistemaInmunologicoPage";
import AboutSaraiPage from "@/pages/AboutSaraiPage";
import Esperanza from "@/pages/Esperanza";
import BlogHub from "@/pages/blog/BlogHub";
import BlogPost from "@/pages/blog/BlogPost";
import GA4PageTracker from "@/components/GA4PageTracker";
import { AdminAuthProvider } from "@/lib/AdminAuthContext";
import { Toaster } from "sonner";
import { translations } from "@/lib/translations";

function PublicShell({ Component }) {
  const [language, setLanguage] = useState("es");
  const t = useMemo(() => translations[language], [language]);
  return <Component t={t} language={language} setLanguage={setLanguage} />;
}

function App() {
  return (
    <div className="App grain" data-testid="app-root">
      <HelmetProvider>
        <BrowserRouter>
          <GA4PageTracker />
          <AdminAuthProvider>
            <Routes>
              <Route path="/" element={<PublicShell Component={Landing} />} />
              <Route path="/immunocal" element={<PublicShell Component={ImmunocalPage} />} />
              <Route path="/immunocal-precio" element={<PublicShell Component={ImmunocalPrecioPage} />} />
              <Route path="/glutation" element={<PublicShell Component={GlutationPage} />} />
              <Route path="/sistema-inmunologico" element={<PublicShell Component={SistemaInmunologicoPage} />} />
              <Route path="/sobre-sarai" element={<PublicShell Component={AboutSaraiPage} />} />
              <Route path="/esperanza" element={<Esperanza />} />
              <Route path="/blog" element={<PublicShell Component={BlogHub} />} />
              <Route path="/blog/:slug" element={<PublicShell Component={BlogPost} />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/studio" element={<ProtectedRoute><ContentStudio /></ProtectedRoute>} />
              <Route path="/admin/reels" element={<ProtectedRoute><ReelsStudio /></ProtectedRoute>} />
              <Route path="/admin/newsletter" element={<ProtectedRoute><NewsletterPanel /></ProtectedRoute>} />
              <Route path="/admin/broadcast" element={<ProtectedRoute><BroadcastComposer /></ProtectedRoute>} />
              <Route path="/admin/leads/:id" element={<ProtectedRoute><AdminLeadDetail /></ProtectedRoute>} />
            </Routes>
          </AdminAuthProvider>
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
